// eslint-disable-next-line no-shadow
export enum RendernetErrors {
	INSUFFICIENT_CREDITS = 'AC01',
	BLOCKED_USER = 'AC02',
	DELETED_USER = 'AC05',
	USER_NOT_FOUND = 'AC04',
	INSUFFICIENT_FACELOCKS = 'AC03',
	FACE_NOT_FOUND = 'AT09',
	TIMEOUT = 'TO01',

	INVALID_GENERATION_TYPE = 'GE01',
	TOO_MANY_PENDING_IMAGES = 'GE02',
	NSFW_PROMPT = 'GE03',
	INVALID_QUALITY = 'GE04',
	INVALID_MODELS = 'GE05',
	TOO_MANY_VIDEO_GENERATIONS = 'GE15',
	TOO_MANY_LIPSYNC_GENERATIONS = 'GE16',
	CONTENT_MODERATION = 'GE20',
	BLOCK_USER_DUE_TO_CONTENT_MODERATION = 'GE21',
	VIDEO_ANYONE_FAL_GENERATIONS = 'PR06',

	INVALID_CANVAS_ID = 'CN01',
	CANVAS_LIMIT_REACHED = 'CN02',
	CANVAS_NOT_PUBLIC = 'CN04',
	MODEL_NOT_FOUND = 'MN01',

	VALIDATION_ERROR = 'GN01',
	METHOD_NOT_ALLOWED = 'GN02',
	SOMETHING_WENT_WRONG_TRY_AGAIN = 'GN03',
	INVALID_CREDENTIALS = 'GN04',

	STRIPE_INTERACTION_ERROR = 'SN02',
	STRIPE_INVALID_COUPON_CODE = 'SN06',
}
